module.exports = __webpack_public_path__ + "static/img/logo13.eccaaf33.png";